import { ApiDateSchema } from '@weft/types';
import type { ZapiParam } from '@weft/zapi-types';

export const END_TIME_QUERY_PARAM = {
  name: 'endTime',
  location: 'query',
  schema: ApiDateSchema,
  required: true,
} as const satisfies ZapiParam;

export const OPTIONAL_END_TIME_QUERY_PARAM = {
  name: 'endTime',
  location: 'query',
  schema: ApiDateSchema.optional(),
  required: false,
} as const satisfies ZapiParam;